import React from "react";
import { IMAGES } from "../localConstants/images";
import { Navbar } from "./Navbar";
import { Sidebar } from "./Sidebar";

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="dark min-h-screen bg-black text-white relative overflow-hidden dark font-roboto">
      {/* Background patterns */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${IMAGES.BACKGROUND})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.6,
        }}
      />

      {/* Mobile Navbar */}
      <Navbar />

      {/* Desktop Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <main className="dark lg:ml-64 pt-16 md:pt-20 lg:pt-6 z-10 relative font-roboto ">
        <div className="p-4 md:p-6">{children}</div>
      </main>
    </div>
  );
};
